import { FC, PropsWithChildren } from "react";

import { cn } from "@/ui/lib";
import { TAlertAssetProps } from "./Alert.config";

export const AlertAssetWrapper: FC<PropsWithChildren<TAlertAssetProps>> = ({ children }) => (
  <>
    { children ? (
      <div
        className={cn(
          "col-start-1 row-start-1",
          "self-start",
        )}
      >
        { children }
      </div>
    ) : null }
  </>
);
